import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { RuleContainer } from "@models/configurators/rule-container";
import { IPriceColumnMap, IPricingRuleContainer } from "@models/entity-models";
import { eRuleType } from "@models/enums";

@Kbo(CToken.PricingRuleContainer)
export class PricingRuleContainer extends RuleContainer implements IPricingRuleContainer {
    constructor(kom: KbObjectManager) {
        super(kom, { ruleType: eRuleType.pricing });

    }

    public fillFromSource: string;
    public idTable: number;
    public dbTable: string;

    public skuColumn: string;
    public mediaColumn: string;
    public descriptionColumn: string;
    public unitOfMeasureColumn: string;
    public materialCostColumn: string;
    public materialMarginColumn: string;
    public laborCostColumn: string;
    public laborMarginColumn: string;
    public requiresUpdate: boolean;

    private _columnMaps: IPriceColumnMap[];
    @Enumerable()
    public get columnMaps(): IPriceColumnMap[] {
        if (!this._columnMaps) this._columnMaps = [];
        return this._columnMaps;
    }
    public set columnMaps(val) {
        this._columnMaps = val;
    }

}
